import { render, staticRenderFns } from "./ContactWireAddUpdate.vue?vue&type=template&id=1b5644de"
import script from "./ContactWireAddUpdate.vue?vue&type=script&lang=js"
export * from "./ContactWireAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports